var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9325 22.9441H28.3525L27.7925 22.4041C30.1925 19.6041 31.4325 15.7841 30.7525 11.7241C29.8125 6.16408 25.1725 1.74408 19.5925 1.04408C12.0125 0.104084 5.53253 5.70408 4.99253 12.9441H9.03253C9.51253 8.70408 12.8725 5.34408 17.1525 4.98408C22.2325 4.54408 26.9325 8.84408 26.9325 13.9441C26.9325 18.9241 22.9125 22.9441 17.9325 22.9441C17.5925 22.9441 17.2725 22.8841 16.9325 22.8441V26.8841C16.9325 26.8841 16.9325 26.8841 16.9525 26.9041C20.5525 27.1641 23.8925 25.9641 26.3925 23.8041L26.9325 24.3641V25.9441L35.4325 34.4441C36.2525 35.2641 37.5925 35.2641 38.4125 34.4441C39.2325 33.6241 39.2325 32.2841 38.4125 31.4641L29.9325 22.9441Z",
    fill: "#C6C9C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1725 17.2841L6.93253 21.5241L2.69253 17.2841C2.29253 16.8841 1.67253 16.8841 1.27253 17.2841C0.872534 17.6841 0.872534 18.3041 1.27253 18.7041L5.51253 22.9441L1.27253 27.1841C0.872534 27.5841 0.872534 28.2041 1.27253 28.6041C1.67253 29.0041 2.29253 29.0041 2.69253 28.6041L6.93253 24.3641L11.1725 28.6041C11.5725 29.0041 12.1925 29.0041 12.5925 28.6041C12.9925 28.2041 12.9925 27.5841 12.5925 27.1841L8.35253 22.9441L12.5925 18.7041C12.9925 18.3041 12.9925 17.6841 12.5925 17.2841C12.1925 16.9041 11.5725 16.9041 11.1725 17.2841Z",
    fill: "#C6C9C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNotFound);
export default __webpack_public_path__ + "static/media/SearchNotFound.c56990284d820d1c6336e055aa2ea6b9.svg";
export { ForwardRef as ReactComponent };